var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.364 0.631753C8.42149 0.63165 8.47844 0.64288 8.53159 0.6648C8.58474 0.68672 8.63305 0.718901 8.67375 0.759503L13.005 5.09075C13.087 5.1728 13.1331 5.28406 13.1331 5.40007C13.1331 5.51608 13.087 5.62733 13.005 5.70938C12.585 6.12938 12.067 6.22388 11.6899 6.22388C11.535 6.22388 11.3967 6.20813 11.2874 6.18975L8.54513 8.932C8.61731 9.22286 8.66416 9.51943 8.68512 9.81838C8.72537 10.4326 8.65713 11.2945 8.05513 11.8965C7.97308 11.9785 7.86182 12.0246 7.74581 12.0246C7.6298 12.0246 7.51854 11.9785 7.4365 11.8965L4.96112 9.422L2.17687 12.2063C2.00625 12.3769 1.11025 12.9955 0.939625 12.8249C0.769 12.6543 1.38762 11.7574 1.55825 11.5876L4.3425 8.80338L1.868 6.328C1.78598 6.24596 1.73991 6.1347 1.73991 6.01869C1.73991 5.90268 1.78598 5.79142 1.868 5.70938C2.47 5.10738 3.33187 5.03825 3.94612 5.07938C4.24508 5.10033 4.54165 5.14717 4.8325 5.21938L7.57475 2.478C7.55186 2.34476 7.54015 2.20983 7.53975 2.07463C7.53975 1.69838 7.63425 1.18038 8.05513 0.759503C8.13712 0.677717 8.24819 0.631777 8.364 0.631753Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.ec2b4e1cecedd8b1b7762b3d5f020b19.svg";
export { ForwardRef as ReactComponent };